export default __webpack_public_path__ + "static/media/the_Product-two.f61e6169.png";